import { Info } from "@shared/v2/Icomoon";
import Tooltip from "@shared/v2/Tooltip";

const CompletenessTooltip = () => (
  <span className="tw-pl-[4px]">
    <Tooltip
      content={<div className="tw-w-[180px] tw-text-left">Leads missing either name or email</div>}
      trigger={<Info size="m" className="tw-text-gray-75" />}
      placement="top"
    />
  </span>
);

export default CompletenessTooltip;
